export default [
   {
        show(row, extra) {
            return (
                row.shbj === '1'
                || row.shbj === '9'
            );
        },
        tag: 'my-btn',
        type: 'detail',
        text: '详情',
        click(row, extra) {
            this.goto({
                path: 'detail',
                query: {
                    id: row.yqscode,
                    procode: extra.procode,
                    isXt:extra.isXt
                }
            })
        }
    }, 
    {
        show(row, extra) {
  
            return (
                row.proxx&&row.shbj==='1')
        },
        tag: 'my-btn',
        type: 'detail',
        text: '发布邀请书',
        click(row, extra) {
            var that = this
            ShowConfirm('是否发布邀请书？', 'danger', () => {
                that.$get(`${this.getGetters('bidUrl')}/FangAn/TbYqs/upstatus.json`, {
                    yqscode:row.yqscode,
                    t:Math.random() 
                }, (data, res) => {
                    ShowMsg('发布成功', 'success');
                    that.$emit('reload')
                });
            });
        }
    },{
        show(row, extra) {
            return (
                !(
                    row.shbj === '1'
                    || row.shbj === '9'
                )
            );
        },
        tag: 'my-btn',
        type: 'del',
        text: '删除',
        click(row, extra) {
            this.$emit('del');
        }
    }, {
        show(row, extra) {
            return (
                !(
                    row.shbj === '1'
                    || row.shbj === '9'
                )
            );
        },
        tag: 'my-btn',
        type: 'edit',
        text: '修改',
        click(row, extra) {
            console.log(extra)
            this.goto({
                path: 'form',
                query: {
                    id: row.yqscode,
                    procode: extra.procode_encrypt,
                    isXt:extra.isXt
                   
                }
            })
        }
    }
]
